import React, { useState, useEffect } from "react"
import Page from "@smpu-web/globalmodules/page"
import InfoBox from "./infobox"
import "../assets/style.scss"
import { useGetConfigMutation } from "../../../api/services"

const Campaign = () => {
  const [campaingsText, setCampaingsText] = useState<any[]>([]);
  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("UniversiteliAkbankli.Landing.Campaings")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaingsText(JSON.parse(payload.configValue))
        }
      })
  }, [getConfig])

  const infobox = () => {
    return campaingsText.map((item: any, index) => {
      return (
        <InfoBox key={item.id} id={"infobox" + item.id} img={item.image} text1={item.name} />
      );
    });
  }

  return (
    <Page padding={false}>
      {campaingsText && infobox()}
    </Page>
  )
}

export default Campaign
